import { DemoViewMode, demoViewModeKey } from '../types/DemoViewMode';
import { wixSdkAdapter } from './wixSdkAdapter';

export const getDemoViewMode = (): Promise<DemoViewMode> =>
  wixSdkAdapter
    .getPublicDataItem(demoViewModeKey)
    .then((demoViewMode: DemoViewMode) => demoViewMode || DemoViewMode.WithoutCards);
